import { render } from "./HomeFAQ.vue?vue&type=template&id=60444ec0"
import script from "./HomeFAQ.vue?vue&type=script&lang=js"
export * from "./HomeFAQ.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__